import React, { useMemo } from "react";
import { useScheduleTemplates } from "@api/scheduleTemplate.api";
import { BaseFilterProps } from "../../lib";
import { OptionsMultiselectFilter } from "./OptionsMultiselectFilter";
import { buildScheduleGroupOptions } from "./schedulesReportFilterOptions";

export const SchedulesReportGroupFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { data: templates } = useScheduleTemplates({
        includeMilestone: true,
    });
    const options = useMemo(
        () => buildScheduleGroupOptions(templates ?? []),
        [templates],
    );

    return (
        <OptionsMultiselectFilter
            options={options}
            selectedIds={filters.scheduleGroups ?? []}
            onChange={(scheduleGroups) => onChange({ scheduleGroups })}
            name="schedulesReportGroup"
        />
    );
};
